import { useState } from "react";
import { CancelButton } from "../../../../components/ui/CancelButton";
import { UserActions } from "../../PanelActions/enums"; 
import { useGetUserByIdQuery } from "../../../../api/userApi";
import { CircularProgress } from "@mui/joy";
import { ModalContainer } from "../../../../components/ui/ModalContainer";
import { ChangeUserStatusForm } from "./ChangeUserStatusForm";
import { useAdminPanelUI } from "../../../../hooks/useAdminPanelUI";

interface Props {
    userId: number;
}

export function UserDetails({ userId }: Props) {
    const { setUserAction } = useAdminPanelUI();
    const [openModal, setOpenModal] = useState(false);

    const height="h-[35px]"
    const width="w-[300px]"

    const { data: userInfo, isLoading, isSuccess } = useGetUserByIdQuery(userId);

    return (
        <div className="h-full w-full m-3">
            {isLoading
            ? 
            <div className="flex justify-center items-center h-full w-full">
                <CircularProgress />
            </div>
            :
            <>
            {isSuccess && (
            <>
            <div>
                <p className="text-xl font-semibold mb-2">Informacion del usuario</p>

                <div className="flex gap-x-4 mb-2">
                    <div>
                        <div className="grid">
                            <label className="text-[13px] font-semibold">Nombre</label>
                            <input 
                                disabled
                                value={userInfo.nombre}
                                className={`${width} ${height} rounded-[3px] border-gray-400 border px-2 
                                    font-semibold text-gray-600 text-sm`}
                                type={"text"}/>
                        </div>
                    </div>
                    
                    <div>
                        <div className="grid">
                            <label className="text-[13px] font-semibold">Usuario</label>
                            <input 
                                disabled
                                value={userInfo.username}
                                className={`${width} ${height} rounded-[3px] border-gray-400 border px-2 
                                    font-semibold text-gray-600 text-sm`}
                                type={"text"}/>
                        </div>
                    </div>


                    <div>
                        <div className="grid">
                            <label className="text-[13px] font-semibold">Correo</label>
                            <input 
                                disabled
                                value={userInfo.correo}
                                className={`${width} ${height} rounded-[3px] border-gray-400 border px-2 
                                    font-semibold text-gray-600 text-sm`}
                                type={"text"}/>
                        </div>
                    </div>

                    <div>
                        <div className="grid">
                            <label className="text-[13px] font-semibold">Rol</label>
                            <input 
                                disabled
                                value={userInfo.rol}
                                className={`${width} ${height} rounded-[3px] border-gray-400 border px-2 
                                    font-semibold text-gray-600 text-sm`}
                                type={"text"}/>
                        </div>
                    </div>
                </div>

                <p className="text-xl font-semibold mt-8">Estatus: {userInfo.estatus}</p>
            </div>

            <div className="border border-gray-500 my-8"></div>

            <p className="text-xl font-semibold mb-2">Acciones</p>

            <div className="flex gap-x-10 items-center">
                {userInfo?.estatus == "Activo"
                ? 
                <>
                <p className="font-semibold">Desactivar cuenta del usuario</p>
                <button
                    onClick={() => setOpenModal(true)}
                    className="border-2 border-red-300 rounded-[3px] px-[6px] py-[2px] flex gap-1 items-center hover:bg-red-100">
                    <p className="text-red-400 text-[13px] font-semibold text-center">Desactivar</p>
                </button>
                </>
                :
                <>
                <p className="font-semibold">Reactivar cuenta del usuario</p>
                <button
                    onClick={() => setOpenModal(true)}
                    className="border-2 border-green-600 bg-green-100 rounded-[3px] px-[6px] py-[2px] flex gap-1 items-center hover:bg-green-300">
                    <p className="text-green-800 text-[13px] font-semibold text-center">Reactivar</p>
                </button>
                </>
                }
            </div>

            {openModal && (
                <ModalContainer>
                    <ChangeUserStatusForm
                        setOpenModal={setOpenModal}
                        currentStatus={userInfo.estatus}
                        userId={userInfo.id}
                        name={userInfo.nombre}/>
                </ModalContainer>
            )}

            </>
            )}
            </>
            }

            <div className="flex justify-center my-4">
                <CancelButton
                    text="Regresar"
                    onClick={()=> setUserAction(UserActions.UserList)}/>
            </div>
        </div>
    );
}
